module.exports = __webpack_public_path__ + "static/media/07-news-detail3.f70fa5f5.png";